export const Version = {
	version: '3.23.0-dev.39.4295'
};
